var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsahaJangkaPanjang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 128.625,
    viewBox: "0 0 104 128.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.84,
    y1: 0.13,
    x2: 0.14,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0783d",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152 -331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(152 331)",
    opacity: 0.266,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.299 102.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.686,8.48a6.156,6.156,0,1,0,0,12.311H7.752v2.276H42.318V20.791c0-5.356-3.547-12.155-8.853-12.311Z",
    transform: "translate(-0.53 29.899)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.946,304.09a13.01,13.01,0,1,1-13.01-13.01,13.01,13.01,0,0,1,13.01,13.01Z",
    transform: "translate(34.081 -240.475)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.509,304.09A13.01,13.01,0,1,1,15.5,291.08a13.01,13.01,0,0,1,13.01,13.01Z",
    transform: "translate(1.797 -240.475)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.921,280.6H34.1a4.3,4.3,0,0,1,4.314,4.314v29.685a4.3,4.3,0,0,1-4.314,4.314H5.921a4.3,4.3,0,0,1-4.314-4.314V284.91A4.3,4.3,0,0,1,5.921,280.6Z",
    transform: "translate(-1.58 -280.596)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.418,280.6v11.452a2.022,2.022,0,0,0,2.028,2.025h5.606a2.022,2.022,0,0,0,2.028-2.025V280.6Z",
    transform: "translate(9.179 -280.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,284.375c-1.921,0-1.78,2.969.138,2.877H9.546a1.438,1.438,0,0,0,0-2.877Z",
    transform: "translate(3.077 -266.133)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25,285.69a1.438,1.438,0,1,0,0,2.877H14.675a1.438,1.438,0,0,0,0-2.877Z",
    transform: "translate(3.033 -261.1)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.784,287.546a2.877,2.877,0,0,0-2.166,4.766h25.51A4.289,4.289,0,0,0,33.442,288v-.452Z",
    transform: "translate(3.39 -254)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.026 18.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.773,4.379l4.782,19.953c2.913,11.761-9.4,12.154-9.4,12.154H7.731A17.372,17.372,0,0,0,1,46.02c-.817,3.762-.794,4.953,1.964,4.953H73.546c2.319,0,4.273-2.441,3.567-5.722L67.219,4.379Z",
    transform: "translate(-0.535 -4.379)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.869,17.274H58.359c1.91,0,3.546-1.671,3.677-4.09H7.063A2.745,2.745,0,0,0,4.869,17.274Z",
    transform: "translate(14.653 29.32)",
    fill: "#a29292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.47,4.379c-2.236,1.7-1.22,5.726,2.483,5.726h7.66q-.693-2.863-1.387-5.726Z",
    transform: "translate(44.457 -4.379)",
    fill: "#a29292"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.624,282.2a5.98,5.98,0,0,0-6.146,6.146,6.132,6.132,0,0,0,6.146,6.146H34.593l-2.086-9.677a3.512,3.512,0,0,0-3.636-2.614Z",
    transform: "translate(32.368 -274.465)",
    fill: "#ffca3a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsahaJangkaPanjang);
export default __webpack_public_path__ + "static/media/usaha-jangka-panjang.4beb6518e559f9f8ce83b847a59b7ae4.svg";
export { ForwardRef as ReactComponent };